import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { enqueueSnackbar } from "notistack";
import {
  createGeneralAPIEndpoint,
  EducationStageEndPoints,
} from "../../../services/General";

export default function EducationStage() {
  const [stages, setStages] = useState([]);

  const [open, setOpen] = useState(false);

  const [editing, setEditing] = useState(null);

  const [form, setForm] = useState({
    nameAr: "",
    nameEn: "",
  });

  useEffect(() => {
    loadStages();
  }, []);

  const loadStages = () => {
    createGeneralAPIEndpoint(EducationStageEndPoints.all)
      .fetch()
      .then((res) => setStages(res.data))
      .catch(() =>
        enqueueSnackbar("Failed to load stages", {
          variant: "error",
        }),
      );
  };

  const handleOpen = (stage = null) => {
    if (stage) {
      setEditing(stage);

      setForm({
        nameAr: stage.nameAr,
        nameEn: stage.nameEn,
      });
    } else {
      setEditing(null);

      setForm({
        nameAr: "",
        nameEn: "",
      });
    }

    setOpen(true);
  };

  const handleSave = () => {
    if (!form.nameAr || !form.nameEn) {
      enqueueSnackbar("Please fill all fields", {
        variant: "warning",
      });
      return;
    }

    createGeneralAPIEndpoint(EducationStageEndPoints.create)
      .postWithToken(form)
      .then(() => {
        enqueueSnackbar(
          editing ? "Updated Successfully" : "Added Successfully",
          {
            variant: "success",
          },
        );

        setOpen(false);

        loadStages();
      })
      .catch(() =>
        enqueueSnackbar("Operation failed", {
          variant: "error",
        }),
      );
  };

  return (
    <Box p={3}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
        className="header"
      >
        <h1 className="header-title">Education Stages</h1>

        <Button
          startIcon={<AddIcon />}
          onClick={() => handleOpen()}
          className="add-button"
        >
          Add Stage
        </Button>
      </Box>

      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fill,minmax(280px,1fr))"
        gap={2}
        className="stages-grid"
      >
        {stages.map((stage) => (
          <Card key={stage.id}>
            <CardContent>
              <h2 className="stage-name">{stage.nameAr}</h2>

              <h2
                color="text.secondary"
                sx={{ mb: 2 }}
                className="stage-name-en"
              >
                {stage.nameEn}
              </h2>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
        className="stage-dialog"
      >
        <DialogTitle>{editing ? "Edit Stage" : "Add Stage"}</DialogTitle>

        <DialogContent dividers>
          <TextField
            fullWidth
            label="Arabic Name"
            margin="normal"
            value={form.nameAr}
            onChange={(e) =>
              setForm({
                ...form,
                nameAr: e.target.value,
              })
            }
            className="arabic-name-field"
          />

          <TextField
            fullWidth
            label="English Name"
            margin="normal"
            value={form.nameEn}
            onChange={(e) =>
              setForm({
                ...form,
                nameEn: e.target.value,
              })
            }
            className="english-name-field"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)} className="cancel-button">
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSave}
            className="save-button"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
